/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryPattern
 */
export interface DeliveryPattern {
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    frequency_units_code?: string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPattern
     */
    period?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPattern
     */
    period_units_code?: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    period_units_code_definition?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    quantity?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    quantity_units_code?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    quantity_units_code_definition?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    delivery_pattern_qualifier_code?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    delivery_pattern_qualifier_definition?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    delivery_pattern_time_qualifier_code?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    delivery_pattern_time_qualifier_definition?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    time_period_qualifier_code?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    time_period_qualifier_definition?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    measurement_units_code?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPattern
     */
    measurement_units_code_definition?: string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPattern
     */
    number_of_periods?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPattern
     */
    sample_selection_modulus?: number;
}

/**
 * Check if a given object implements the DeliveryPattern interface.
 */
export function instanceOfDeliveryPattern(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeliveryPatternFromJSON(json: any): DeliveryPattern {
    return DeliveryPatternFromJSONTyped(json, false);
}

export function DeliveryPatternFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryPattern {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'frequency_units_code': !exists(json, 'frequency_units_code') ? undefined : json['frequency_units_code'],
        'period': !exists(json, 'period') ? undefined : json['period'],
        'period_units_code': !exists(json, 'period_units_code') ? undefined : json['period_units_code'],
        'period_units_code_definition': !exists(json, 'period_units_code_definition') ? undefined : json['period_units_code_definition'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'quantity_units_code': !exists(json, 'quantity_units_code') ? undefined : json['quantity_units_code'],
        'quantity_units_code_definition': !exists(json, 'quantity_units_code_definition') ? undefined : json['quantity_units_code_definition'],
        'delivery_pattern_qualifier_code': !exists(json, 'delivery_pattern_qualifier_code') ? undefined : json['delivery_pattern_qualifier_code'],
        'delivery_pattern_qualifier_definition': !exists(json, 'delivery_pattern_qualifier_definition') ? undefined : json['delivery_pattern_qualifier_definition'],
        'delivery_pattern_time_qualifier_code': !exists(json, 'delivery_pattern_time_qualifier_code') ? undefined : json['delivery_pattern_time_qualifier_code'],
        'delivery_pattern_time_qualifier_definition': !exists(json, 'delivery_pattern_time_qualifier_definition') ? undefined : json['delivery_pattern_time_qualifier_definition'],
        'time_period_qualifier_code': !exists(json, 'time_period_qualifier_code') ? undefined : json['time_period_qualifier_code'],
        'time_period_qualifier_definition': !exists(json, 'time_period_qualifier_definition') ? undefined : json['time_period_qualifier_definition'],
        'measurement_units_code': !exists(json, 'measurement_units_code') ? undefined : json['measurement_units_code'],
        'measurement_units_code_definition': !exists(json, 'measurement_units_code_definition') ? undefined : json['measurement_units_code_definition'],
        'number_of_periods': !exists(json, 'number_of_periods') ? undefined : json['number_of_periods'],
        'sample_selection_modulus': !exists(json, 'sample_selection_modulus') ? undefined : json['sample_selection_modulus'],
    };
}

export function DeliveryPatternToJSON(value?: DeliveryPattern | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'frequency_units_code': value.frequency_units_code,
        'period': value.period,
        'period_units_code': value.period_units_code,
        'period_units_code_definition': value.period_units_code_definition,
        'quantity': value.quantity,
        'quantity_units_code': value.quantity_units_code,
        'quantity_units_code_definition': value.quantity_units_code_definition,
        'delivery_pattern_qualifier_code': value.delivery_pattern_qualifier_code,
        'delivery_pattern_qualifier_definition': value.delivery_pattern_qualifier_definition,
        'delivery_pattern_time_qualifier_code': value.delivery_pattern_time_qualifier_code,
        'delivery_pattern_time_qualifier_definition': value.delivery_pattern_time_qualifier_definition,
        'time_period_qualifier_code': value.time_period_qualifier_code,
        'time_period_qualifier_definition': value.time_period_qualifier_definition,
        'measurement_units_code': value.measurement_units_code,
        'measurement_units_code_definition': value.measurement_units_code_definition,
        'number_of_periods': value.number_of_periods,
        'sample_selection_modulus': value.sample_selection_modulus,
    };
}

